import { IRetailer } from "@faire/web-api--source/indigofair/data/IRetailer";

export const isOwfGrantIneligibleStore = (
  reportedCreationTime: keyof typeof IRetailer.ReportedCreationTime | undefined,
  canApplyToOwf: boolean | undefined
): boolean => {
  // if the retailer can apply to the OWF grant, they are automatically eligible
  if (canApplyToOwf) {
    return false;
  }

  if (
    [
      undefined,
      IRetailer.ReportedCreationTime.OPENING_SOON,
      IRetailer.ReportedCreationTime.STARTED_THIS_YEAR,
      IRetailer.ReportedCreationTime.STARTED_ONE_YEAR_AGO,
    ].includes(reportedCreationTime as IRetailer.ReportedCreationTime)
  ) {
    return false;
  }

  return true;
};
